import { computed, ref } from "vue"

export type Theme = "light" | "dark"
const initial = typeof localStorage !== "undefined" && localStorage.getItem("codexnow-theme") === "dark" ? "dark" : "light"
const theme = ref<Theme>(initial)

function apply(): void {
  document.documentElement.dataset.theme = theme.value
  document.documentElement.style.colorScheme = theme.value
}

export function useTheme() {
  apply()
  const isDark = computed(() => theme.value === "dark")

  function toggle(): void {
    theme.value = theme.value === "dark" ? "light" : "dark"
    localStorage.setItem("codexnow-theme", theme.value)
    apply()
  }

  return { theme, isDark, toggle }
}
